"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embeddedAuthProvider = exports.PostMessageTypes = void 0;
const query_string_1 = __importDefault(require("query-string"));
var PostMessageTypes;
(function (PostMessageTypes) {
    PostMessageTypes["ReceiveUser"] = "receive-user";
    PostMessageTypes["RequestUser"] = "request-user";
})(PostMessageTypes = exports.PostMessageTypes || (exports.PostMessageTypes = {}));
const embeddedAuthProvider = (getUserData, { authQuery, window }) => {
    const trustedEmbeds = new Set();
    const embeddedQueryKey = 'embedded';
    const embeddedQueryValue = 'true';
    const messageHandler = event => {
        if (event.data.type === PostMessageTypes.RequestUser && trustedEmbeds.has(event.origin)) {
            getUserData().then(data => {
                event.source.postMessage({ type: PostMessageTypes.ReceiveUser, userData: data }, event.origin);
            });
        }
    };
    window.addEventListener('message', messageHandler);
    const getAuthorizedEmbedUrl = (urlString, extraParams) => {
        const url = new URL(urlString);
        trustedEmbeds.add(url.origin);
        const params = query_string_1.default.parse(url.search);
        url.search = query_string_1.default.stringify({
            ...params,
            ...extraParams,
            ...(authQuery && authQuery.value ? { [authQuery.key]: authQuery.value } : { auth: 'embedded' }),
            [embeddedQueryKey]: embeddedQueryValue,
            subcontent: 'true',
        });
        return url.href;
    };
    return {
        embeddedQueryKey,
        embeddedQueryValue,
        getAuthorizedEmbedUrl,
        unmount: () => {
            window.removeEventListener('message', messageHandler);
        }
    };
};
exports.embeddedAuthProvider = embeddedAuthProvider;
